// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, object, oneOfType, string } from 'prop-types'
import { UpdatedLabeledInputWrapper } from './styles'
import UpdatedInputBase from '../UpdatedInputBase'

import {
  ErrorSimple,
  LabelSimple,
  LookupWrapper,
} from 'components/Form'

// NOTE - if you pass "lookup" as an empty string, it will adjust the grid to account for the space the lookup would occupy.
// This allows for easy vertical alignment on pages like Path Details where the layout strongly accounts for this lookup space.

class UpdatedLabeledInput extends UpdatedInputBase {
  static propTypes = {
    autoFocus: bool,
    clearable: oneOfType([
      bool,
      func,
    ]),
    clearWhenDisabled: bool,
    disabled: bool,
    id: string.isRequired,
    input: object.isRequired,
    label: oneOfType([
      string,
      object,
    ]),
    lookup: oneOfType([
      string,
      object,
    ]),
    meta: object.isRequired,
    onBlurCustom: func,
    onChangeCustom: func,
    onFocusCustom: func,
    onPasteCustom: func,
    placeholder: string,
    readOnly: bool,
    type: string,
    unitLabel: oneOfType([
      string,
      object,
    ]),
  }

  static defaultProps = {
    clearWhenDisabled: false,
    className: '',
    lookup: null,
  }

  handleClear = () => {
    const {
      clearable,
      input,
    } = this.props

    // make sure that we're to support clearing.
    if (!clearable) {
      return
    }

    if (typeof clearable === 'function') {
      clearable()
    } else {
      input.onChange('')
    }
  }

  handlePaste = e => {
    const {
      input: { onChange },
      onPasteCustom,
    } = this.props

    // if onPasteCustom is defined, then call that, otherwise treat the paste as a simple change event.
    if (typeof onPasteCustom === 'function') {
      onPasteCustom(e, onChange)
    } else {
      onChange(e)
    }
  }

  render () {
    const {
      autoFocus,
      className,
      clearable,
      clearWhenDisabled,
      disabled,
      id,
      input,
      label,
      lookup,
      meta,
      placeholder,
      readOnly,
      type,
      unitLabel,
    } = this.props

    const {
      asyncValidating,
      error,
    } = meta

    return (
      <UpdatedLabeledInputWrapper
        className={`updated-labeled-input ${className}`}
        title={input.value}>
        <LabelSimple
          idRoot={id}
          label={label} />
        <input
          {...input}
          autoFocus={autoFocus}
          className={'input'}
          disabled={disabled}
          id={id}
          placeholder={placeholder}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          onFocus={this.handleFocus}
          onPaste={this.handlePaste}
          readOnly={readOnly}
          type={type} />
        {
          (clearable && (clearWhenDisabled || !disabled) && !!input.value) &&
          <i
            className={'clear-input pointer fa fa-times'}
            id={`${id}-clear`}
            onClick={this.handleClear} />
        }
        {
          asyncValidating &&
          <i className={'loading fa fa-spinner fa-pulse fa-fw'} />
        }
        {
          unitLabel &&
          <span className={'unit-label'}>{unitLabel}</span>
        }
        <LookupWrapper
          lookup={lookup} />
        <ErrorSimple
          error={error}
          idRoot={id} />
      </UpdatedLabeledInputWrapper>
    )
  }
}

export default UpdatedLabeledInput
